import { lazy } from 'react';
const FormCupDescrizioneAgenda = lazy(() => import("./CupAgenda/FormCupDescrizioneAgenda"));
const FormCupConfigurazioniRisorse = lazy(() => import("./CupConfigurazioneRisorse/FormCupConfigurazioniRisorse"));
const ConfigurazioneRisorseTable = lazy(() => import("./CupConfigurazioneRisorse/ConfigurazioneRisorseTable"));
const FormCupDisponibilita = lazy(() => import("./CupDisponibilita/FormCupDisponibilita"));
const CupDisponibilitaTable = lazy(() => import("./CupDisponibilita/CupDisponibilitaTable"));
const CupPrenotazioniForm = lazy(() => import("./CupPrenotazioni/CupPrenotazioniForm"));
const CupPrenotaForm = lazy(() => import("./CupPrenotazioni/CupPrenotaForm"));
const CupUtenteForm = lazy(() => import("./CupUtenti/cupUtenteForm"));
const CupPrenotazioniRisorse = lazy(() => import("./CupPrenotazioni/CupPrenotazioniRisorse"));
const CupCalendario = lazy(() => import("./CupCalendario/CupCalendario"));
const CupGestionePrenota = lazy(() => import("./CupPrenotazioni/CupGestionePrenota"));

const DashboardTabelleCup = lazy(() => import("./DashboardTabelleCup"));
const ListInTable = lazy(() => import("../tabellaPocr/ElencoGenerale/ListInTable"));
const EsamiRisorseTable = lazy(() => import("./CupEsamiRisorse/EsamiRisorseTable"));
const EsamiRisorseForm = lazy(() => import("./CupEsamiRisorse/FormCupEsamiRisorseTable"));
const CupRisorse = lazy(() => import("./CupRisorse/FormCupRisorseTable"));
const CupFestivita = lazy(() => import("./CupFestivita/FormCupFestivitaTable"));

const cupRoutes = [
    // Dashboard tabelle cup
    {
        path: "cup",
        element: <DashboardTabelleCup />,
    },
    // Risorse
    {
        path: "cup/risorse",
        element: <CupRisorse />,
    },
    {
        path: "cup/risorse/:id",
        element: <CupRisorse />,
    },
    // Festivita 
    {
        path: "cup/festivita",
        element: <CupFestivita />,
    },
    {
        path: "cup/festivita/:id",
        element: <CupFestivita />,
    },
    // Esami Risorse
    {
        path: "cup/esami-risorse",
        element: <EsamiRisorseTable />,
    },
    {
        path: "cup/esami-risorse/:id",
        element: <EsamiRisorseForm />,
    },
    // Descrizione Agenda
    {
        path: "cup/agenda/edit",
        element: <FormCupDescrizioneAgenda />,
    },
    {
        path: "cup/agenda/edit/:id",
        element: <FormCupDescrizioneAgenda />,
    },
    // Configurazione Risorse 
    {
        path: "cup/modello-agenda",
        element: <ConfigurazioneRisorseTable />,
    },
    {
        path: "cup/modello-agenda/edit",
        element: <FormCupConfigurazioniRisorse />,
    },
    {
        path: "cup/modello-agenda/edit/:ris/:ag",
        element: <FormCupConfigurazioniRisorse />,
    },
    // Disponibilita
    {
        path: "cup/disponibilita",
        element: <CupDisponibilitaTable />,
    },
    {
        path: "cup/disponibilita/edit",
        element: <FormCupDisponibilita />,
    },
    // Prenotazioni
    {
        path: "cup/prenotazioni",
        element: <CupPrenotazioniForm />,
    },
    {
        path: "cup/prenotazioni/overview",
        element: <CupPrenotaForm />,
    },
    {
        path: "cup/prenotazioni/overview/prenota",
        element: <CupGestionePrenota />,
    },
    {
        path: "cup/prenotazioni-risorse",
        element: <CupPrenotazioniRisorse />,
    },
    // Calendario
    {
        path: "cup/calendario",
        element: <CupCalendario />,
    },
    // Utenti
    {
        path: "cup/utenti/edit",
        element: <CupUtenteForm />,
    },
    {
        path: "cup/utenti/edit/:id",
        element: <CupUtenteForm />,
    },
    // QUESTA DEVE ESSERE SEMPRE L'ULTIMA ROUTE
    // Generica tabelle cup
    {
        path: "cup/:id",
        element: <ListInTable isCup="true" />,
    },
];
export default cupRoutes;
